import DeleteIcon from "@mui/icons-material/Delete";
import { set } from "lodash";
import Select from "react-select";

export const OwnerTab = ({
    ownerdata,
    setOwnerdata,
    errors,
    setErrors,
    handleTabChange,
    countryList
}) => {

    const addOwnerRow = () => {
        setOwnerdata([
            ...ownerdata,
            { name: "", designation: "", nationality: null, eid_no: "" }
        ]);
    };

    const removeRow = (index) => {
        if (ownerdata.length > 1) {
            setOwnerdata(ownerdata.filter((_, i) => i !== index));
        }
    };

    const handleOwnerChange = (index, field, value) => {
        const updatedOwners = ownerdata.map((owner, i) =>
            i === index ? { ...owner, [field]: value } : owner
        );
        setOwnerdata(updatedOwners);

        const errorKey = `owner_${field}_${index}`;
        if (errors[errorKey]) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [errorKey]: ""
            }));
        }
    };

    return (
        <div className="tab-pane fade show active">
            <h6 className="border-bottom pb-2 mb-3">Owner / Partners</h6>

            {ownerdata.map((owner, index) => (
                <div key={index} className="border p-3 mb-3 position-relative">

                    {ownerdata.length > 1 && (
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-sm position-absolute"
                            style={{ top: "10px", right: "10px" }}
                            onClick={() => removeRow(index)}
                        >
                            <DeleteIcon fontSize="medium" />
                        </button>
                    )}

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label>Owner/Partner Name {index + 1} *</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors[`owner_name_${index}`] ? "is-invalid" : ""}`}
                                    value={owner.name}
                                    onChange={(e) =>
                                        handleOwnerChange(index, "name", e.target.value)
                                    }
                                />
                                {errors[`owner_name_${index}`] && (
                                    <div className="invalid-feedback">
                                        {errors[`owner_name_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label>Designation *</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors[`owner_designation_${index}`] ? "is-invalid" : ""}`}
                                    value={owner.designation}
                                    onChange={(e) =>
                                        handleOwnerChange(index, "designation", e.target.value)
                                    }
                                />
                                {errors[`owner_designation_${index}`] && (
                                    <div className="invalid-feedback">
                                        {errors[`owner_designation_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label>Nationality *</label>
                                <Select
                                    isClearable
                                    options={countryList}
                                    value={owner.nationality}
                                    onChange={(selectedOption) => {
                                        setOwnerdata(prev => {
                                            const updated = [...prev];
                                            updated[index] = {
                                                ...updated[index],
                                                nationality: selectedOption
                                            };
                                            return updated;
                                        });

                                        const errorKey = `owner_nationality_${index}`;
                                        if (errors[errorKey]) {
                                            setErrors(prev => ({
                                                ...prev,
                                                [errorKey]: ""
                                            }));
                                        }
                                    }}
                                    classNamePrefix="react-select"
                                    className={errors[`owner_nationality_${index}`] ? "border-danger" : ""}
                                />
                                {errors[`owner_nationality_${index}`] && (
                                    <div className="text-danger">
                                        {errors[`owner_nationality_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label>Emirates ID Number *</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors[`owner_eid_no_${index}`] ? "is-invalid" : ""}`}
                                    value={owner.eid_no}
                                    onChange={(e) =>
                                        handleOwnerChange(index, "eid_no", e.target.value)
                                    }
                                />
                                {errors[`owner_eid_no_${index}`] && (
                                    <div className="invalid-feedback">
                                        {errors[`owner_eid_no_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={addOwnerRow}
            >
                + Add Another Owner
            </button>

            <div className="d-flex justify-content-end mt-4">
                <button
                    type="button"
                    className="btn btn-dark btn-sm mr-2"
                    onClick={() => handleTabChange("company")}
                >
                    Back
                </button>
                <button
                    type="button"
                    className="btn btn-info btn-sm"
                    onClick={() => handleTabChange("authorized")}
                >
                    Next
                </button>
            </div>
        </div>
    );
};
